/** Was in einer sortierbaren Spalte stehen kann. Ein Datum als ISO-Text (`2026-10-21…`) sortiert wie ein Datum. */
export type SortWert = string | number | Date | null | undefined

/** Dieselbe Form wie Materials `Sort`, ohne die Lib an `@angular/material/sort` zu binden. */
export interface TabellenSortierung {
  readonly active: string
  readonly direction: 'asc' | 'desc' | ''
}

/**
 * Die Werte einer Spalte sind gleichartig, quer ueber die Spalten aber nicht. Deshalb wird der Typ
 * einmal geprueft und dann typgerecht verglichen. Leere Werte sortieren aufsteigend nach vorn,
 * absteigend also ans Ende. (Dieselbe Form wie `vergleiche` in der internen EKV-Liste und in
 * `kriterien-list`.)
 */
export function vergleicheSortWerte(a: SortWert, b: SortWert): number {
  if (a == null || b == null) {
    return a == null ? (b == null ? 0 : -1) : 1
  }
  if (typeof a === 'number' && typeof b === 'number') {
    return a - b
  }
  if (a instanceof Date && b instanceof Date) {
    return a.getTime() - b.getTime()
  }
  return String(a).localeCompare(String(b), 'de-DE')
}

/**
 * Sortiert eine im Browser vollstaendig geladene Liste nach der Spalte, die `sortierung` nennt, und
 * liefert eine NEUE Liste (das Eingangs-Array bleibt unberuehrt, es liegt meist in einem Signal).
 * Kennt `spaltenWert` die Spalte nicht oder ist keine Richtung gesetzt, bleibt die Reihenfolge der
 * Quelle. Gleiche Werte behalten ihre Reihenfolge (`Array.sort` ist stabil).
 *
 * Nur fuer Listen, die komplett im Browser liegen. Eine seitenweise geladene Liste sortiert im
 * Backend, sonst sortiert sie nur die aktuelle Seite.
 */
export function sortiereTabelle<T>(
  liste: readonly T[],
  sortierung: TabellenSortierung,
  spaltenWert: Readonly<Record<string, (zeile: T) => SortWert>>,
): T[] {
  const wert = spaltenWert[sortierung.active]
  if (!wert || sortierung.direction === '') {
    return [...liste]
  }
  const richtung = sortierung.direction === 'asc' ? 1 : -1
  return [...liste].sort((a, b) => richtung * vergleicheSortWerte(wert(a), wert(b)))
}
